/*------------------------------------*\
    magnify toggle
\*------------------------------------*/

module.exports = function(){


    /*
    $(".js-magnify").each(function(index, el){

        $(el).mlens(
        {
            imgSrc: $(el).attr("data-magnify-src"),      // path of the hi-res version of the image
            imgSrc2x: $(el).attr("data-magnify-src"),  // path of the hi-res @2x version of the image
                                                      //for retina displays (optional)
            lensShape: "circle",                // shape of the lens (circle/square)
            lensSize: ["200px","200px"],            // lens dimensions (in px or in % with respect to image dimensions)
                                                // can be different for X and Y dimension
            borderSize: 2,                  // size of the lens border (in px)
            borderColor: "#fff",            // color of the lens border (#hex)
            borderRadius: 0,                // border radius (optional, only if the shape is square)
            //imgOverlay: $("#gear").attr("data-overlay"), // path of the overlay image (optional)
            overlayAdapt: true,    // true if the overlay image has to adapt to the lens size (boolean)
            zoomLevel: 2,          // zoom level multiplicator (number)
            responsive: true       // true if mlens has to be responsive (boolean)
        });


    });
    */

    /*
    $('.js-magnify-toggle').click(function() {
        $(this).toggleClass('js-magnify-on');

        $.fn.extend({
            toggleText: function(a, b) {
                var that = this;
                    if (that.text() != a && that.text() != b){
                        that.text(a);
                    }
                    else
                    if (that.text() == a){
                        that.text(b);
                    }
                    else
                    if (that.text() == b){
                        that.text(a);
                    }
                return this;
            }
        });
        $('.js-magnify-toggle-text').toggleText('Turn Off', 'Turn On');
    });
    if($('.js-magnify-on').length) {
        $('.js-magnify').magnify();
    }

    $('body').on('click', '.js-magnify-toggle', function() {
        if($('.js-magnify-on').length) {
            $('.js-magnify').magnify();
        }
        else {
            $('.magnify-lens').remove();
        }
    });
    */


}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/magnify.js